// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__wscJt","inputWrap":"styles_inputWrap__1Q_pw","input":"styles_input__OypD1"};